module.exports = __webpack_public_path__ + "img/french-polynesia.ff74caae.svg";